<template>
	<div v-if="options.length > 1" class="c-cops-selector mb-7">
		<input-select 
			v-model="cop"
			:options="options" 
			placeholder="Theme"
		/>
		<small class="c-cops-selector__instruction mt-n7 d-block text-grey">*Change your theme here</small>
	</div>
</template>

<script>
export default {
	name: 'CopsSelector',
	data: () => ({
		cop: null
	}),
	props: {
		options: {
			required: true,
			type: Array
		}
	},
	watch: {
		cop(newVal) {
			window.location = newVal.url
		}
	}
}
</script>

<style>

</style>